import type { Components, CssVarsTheme } from '@mui/material/styles';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiSvgIcon']
>['styleOverrides'] = {
  root: ({ ownerState, theme }) => {
    const colorValue =
      theme.vars.palette[ownerState.color as keyof typeof theme.vars.palette];

    return {
      ...(ownerState.color === 'inherit' && {
        color: 'inherit',
      }),
      ...(ownerState.color === 'action' && {
        color: theme.vars.palette.text.primary,
      }),
      ...(ownerState.color === 'textPrimary' && {
        color: theme.vars.palette.primary.main,
      }),
      ...(ownerState.color === 'textSecondary' && {
        color: theme.vars.palette.text.secondary,
      }),
      ...(ownerState.color === 'disabled' && {
        color: theme.vars.palette.text.disabled,
      }),
      ...(ownerState.color === 'textDisabled' && {
        color: theme.vars.palette.text.disabled,
      }),
      ...(ownerState.color === 'textHeader' && {
        color: theme.vars.palette.text.header,
      }),
      ...(colorValue &&
        typeof colorValue === 'object' &&
        'main' in colorValue && {
          color: colorValue.main,
        }),
      ...(typeof colorValue === 'string' && {
        color: colorValue,
      }),
    };
  },
};

const MuiSvgIcon: Components<CssVarsTheme>['MuiSvgIcon'] = {
  styleOverrides,
};

export default MuiSvgIcon;
